//@ts-nocheck
"use client";

import { useEffect, useState } from "react"
import Hero from "../hero/hero";
import MainContent from "../main-content/main-content";
import styles from './content.module.css';
import NarrativeSlider from "../narrative-slider/narrative-slider";
import NavigationSplit from "../navigation-split/navigation-split";
import HubSpotHero from "../hub-spot-hero/hub-spot-hero";
import { useRouter } from 'next/navigation';
import { vxiContentInterpreter } from "../../utils/vxi-content-interpreter";

export default function Content({ data, newData, left, right }) {
    //console.log("Content component received data:", data);
    const router = useRouter();
    const [whatsNew, setWhatsNew] = useState([]);

    useEffect(() => {
        if (data?.hubSpotLink) {
            router.push(data.hubSpotLink);
        }
    }, [data]);

    useEffect(() => {
        const loadWhatsNew = async () => {
            try {
                const res = await fetch("/api/whats-new", { cache: "no-store" });
                const json = await res.json();
                //console.log("[whats-new] response:", json);

                const list = Array.isArray(json) ? json : json?.data ?? [];
                const interpreted = list.map(item => {
                    const record = item?.data ?? item;
                    return vxiContentInterpreter({
                        ...record?.attributes,
                        id: record?.id,
                        source: item?.source,
                        path: item?.path,
                    });
                });
                //console.log("[whats-new] interpreted:", interpreted);
                setWhatsNew(interpreted);
            } catch (err) {
                console.error("[whats-new] fetch error:", err);
            }
        };
        loadWhatsNew();
    }, []);

    return (
        <div className={styles['content-wrapper']}>
            <Hero
                title={data.title}
                sectionName={`${data.sections} > ${data.types}`}
                images={data.images}
                description={data.heroDescription}
            />
            <MainContent data={data} />
            <NarrativeSlider title="What's new" vxi_contents={whatsNew} />
            {/* {data?.navigationSplit?.left && data?.navigationSplit?.right && (<NavigationSplit left={data?.navigationSplit?.left} right={data?.navigationSplit?.right}/>)} */}
            <NavigationSplit left={data.left} right={data.right} />
        </div>
    )
}
